import { EditableRule, SendableRule, Weekly } from '@/entities/rrule/model';
import { getUnixTime } from 'date-fns';
import { Repeat } from '@/entities/rrule/constants';

export function intoSendableRule(rule: EditableRule): SendableRule {
  const sendableRule = {
    interval: rule.interval,
    repeat: rule.repeat,
    start: getUnixTime(rule.start!),
  };

  switch (rule.frequency) {
    case Repeat.Monthly:
      return {
        ...sendableRule,
        frequency: rule.frequency,
        monthly: rule.monthly,
      };
    case Repeat.Weekly:
      return {
        ...sendableRule,
        frequency: rule.frequency,
        weekly: (Object.keys(rule.weekly!) as Array<keyof Weekly>)
          .filter(day => rule.weekly![day]),
      };
    default:
      return sendableRule;
  }
}
